import React, { useEffect } from 'react'
import { IScheduleRecord } from '../../types/publishSchedule'
import { usePublishScheduleState, useFetchSchedules } from './hooks'
import { StyledList } from './styled'
import { ScheduleListItem } from './ScheduleListItem'

export interface IScheduleList {
  publishTab: boolean
}

export const SchedulesList = ({ publishTab }: IScheduleList) => {
  const state = usePublishScheduleState()
  const fetchSchedules = useFetchSchedules()
  useEffect(() => {
    if (!state.schedulesLoaded && !state.schedulesLoading) {
      fetchSchedules()
    }
  }, [fetchSchedules, state.schedulesLoaded, state.schedulesLoading])

  return (
    <StyledList publishTab={publishTab}>
      {state.schedules.map((schedule: IScheduleRecord) => (
        <ScheduleListItem key={schedule.scheduleId} schedule={schedule} />
      ))}
    </StyledList>
  )
}
